import { plastering } from "@/content/services/plastering";
import { extensions } from "@/content/services/extensions";
import { loftConversions } from "@/content/services/loftConversions";
import { kitchens } from "@/content/services/kitchens";
import { bathrooms } from "@/content/services/bathrooms";
import { refurbishments } from "@/content/services/refurbishments";

export const SERVICE_PAGES = [extensions, plastering, loftConversions, kitchens, bathrooms, refurbishments];
